export default __webpack_public_path__ + "static/media/house6.1e9247ff.jpg";